import {Component} from '@angular/core';
@Component({
    selector: 'app-mandating-flow-info-card',
    templateUrl: './mandating-flow-info-card.component.html',
    styleUrls: ['./mandating-flow-info-card.component.scss'],
    standalone: false
})
export class MandatingFlowInfoCardComponent {
}
